import React, { useEffect } from 'react';
import Rodal from 'rodal';
import { useImmer } from 'use-immer';

import { useDispatch, useSelector } from 'react-redux';

import Card from './card';
import { fetchTicketingProviders } from 'store/collections/ticketing/actions.js';
import Button from 'components/common/Button';
import Spinner from 'components/common/Spinner';
import { NewCredentialModalContent } from './modals';

const SettingsTicketingPage = (props) => {
  const dispatch = useDispatch();
  const collectionName = props.match.params.id;
  const fetchTicketingProviderState = useSelector(
    (state) => state.collection.ticketing.fetch
  );

  const [state, setState] = useImmer({
    toggleAddProvider: false,
    addProviderType: '',
  });

  useEffect(() => {
    dispatch(fetchTicketingProviders(collectionName));
  }, []);

  const onChangeSelect = (value, target) => {
    console.log('on change select', target.name, target);
    setState((draft) => {
      draft[target.name] = value;
    });
  };

  if (fetchTicketingProviderState.loading) {
    return (
      <div className="mx-4 my-4 px-6 py-10 flex items-center justify-center">
        <Spinner loaderSize="lg" />
      </div>
    );
  }

  const renderInfoCards = () => {
    const data = fetchTicketingProviderState?.data;
    const renderCards = data?.length ? (
      data.map((item, index) => (
        <React.Fragment>
          <Card name={item.name} />
        </React.Fragment>
      ))
    ) : (
      <div className="px-2 py-4 text-center bg-gray-200">No results found</div>
    );

    return renderCards;
  };

  return (
    <div id="collection-settings-ticketing" className="">
      <div className="text-right">
        <Button
          intent="primary"
          // showSpinner={true}
          type="button"
          extendClass="text-lg"
          onClick={() => {
            setState((draft) => {
              draft.toggleAddProvider = true;
            });
          }}
          // loading={sendUserInviteTeamState.loading ? true : false}
          //   disable={userLoginState.loading ? false : isSubmitting}
        >
          New Ticketing Provider
        </Button>
      </div>
      <div className="mt-10">{renderInfoCards()}</div>

      <Rodal
        className="rodal-collection-settings-ticketing"
        visible={state.toggleAddProvider}
        onClose={() => {
          setState((draft) => {
            draft.toggleAddProvider = false;
          });
        }}
        customStyles={{
          width: '40%',
          height: '350px',
        }}
        closeMaskOnClick={true}
        closeOnEsc={true}
        animationType="enter"
        showCloseButton={false}
      >
        <NewCredentialModalContent
          addProviderType={state.addProviderType}
          onChangeSelect={onChangeSelect}
        />
      </Rodal>
    </div>
  );
};

export default SettingsTicketingPage;
